import { api } from "./api";

export const glossaryListApi = (params) => {
    return api.get(`/resources/glossary/list`, { params });
};

export const addGlossaryApi = (params) => {
    return api.post(`/resources/glossary/create`, JSON.stringify(params));
};

export const deleteGlossaryApi = (params) => {
    return api.post(`/resources/glossary/delete`, JSON.stringify(params));
};

export const uploadGlossaryFileApi = (params) => {
    return api.post(`/resources/glossary/upload-file`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const translationMemoryListApi = (params) => {
    return api.get(`/resources/translation-memory/list`, { params });
};

// export const deleteTranslationMemoryApi = (params) => {
//     return api.post(`/resources/translation-memory/delete`, JSON.stringify(params));
// };

export const deleteTranslationMemoryApi = (params) => {
    return api.post(`/resources/translation-memory/delete-okapi`, JSON.stringify(params));
};

export const enableDisableTranslationMemoryApi = (params) => {
    return api.post(`/resources/translation-memory/enable-disbale`, JSON.stringify(params));
};

export const exportTranslationMemoryApi = (params) => {
    return api.post(`/resources/translation-memory/export`, JSON.stringify(params));
};